import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";

export const AppContainer = ({ children }: { children: React.ReactNode }) => {
  const { loading } = useAuth();

  return (
    <div className="h-screen overflow-hidden bg-gradient-to-b from-[#126c74] via-[#a89a5c] to-[#126c74] w-full flex">
      {loading ? <Loader2 className="animate-spin text-white self-center w-full" size={48} /> : children}
    </div>
  );
};
